/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterOrigin_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterOrigin_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterOrigin_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterOrigin_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '03e8b2a2aa735b79ce4f02e000d93a97';
module.exports = node;
